import {useQuery} from 'react-query';

import {evalApi} from 'src/lib/api/eval';

export function useEvalSites() {
  const {
    data: sites,
    isLoading,
    error,
  } = useQuery(['eval', 'sites'], () => evalApi.listSites(), {
    cacheTime: 0,
  });

  return {sites, isLoaded: !isLoading, error};
}
